<div *ngIf="modelDetails">
    <div *ngFor="let requirement of modelDetails.modelRequirements; let i = index;">
        <app-requirement-overview [canDelete]="canDelete" [index]="i"></app-requirement-overview>
    </div>
</div>